import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './Accessories.css';

const gold = 'var(--color-accent)';

const categories = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke={gold} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3" />
        <path d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3M5.3 5.3l2.1 2.1M16.6 16.6l2.1 2.1M18.7 5.3l-2.1 2.1M7.4 16.6l-2.1 2.1" />
      </svg>
    ),
    title: 'Performance Parts',
    text: 'Air filters, exhausts, EFI tuning kits, and engine components built to keep your ATV at peak output.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke={gold} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2.5 4.5 5.5v5.2c0 4.6 3.2 7.9 7.5 9.8 4.3-1.9 7.5-5.2 7.5-9.8V5.5L12 2.5Z" />
      </svg>
    ),
    title: 'Protective Gear',
    text: 'Helmets, gloves, body armour, and riding boots engineered for safety on the toughest trails.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke={gold} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3.5 8.5h17v11h-17Z" />
        <path d="M8 8.5V5.8A1.8 1.8 0 0 1 9.8 4h4.4A1.8 1.8 0 0 1 16 5.8v2.7M3.5 13h17" />
      </svg>
    ),
    title: 'Cargo & Storage',
    text: 'Front and rear cargo boxes, rack extensions, and mounting systems for mission-ready hauling.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke={gold} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 18h6M10 21h4M12 3a6 6 0 0 0-3.5 10.9c.7.5 1 1.3 1 2.1h5c0-.8.3-1.6 1-2.1A6 6 0 0 0 12 3Z" />
      </svg>
    ),
    title: 'Lighting & Electrical',
    text: 'LED light bars, auxiliary lamps, winch wiring kits, and dual-battery setups for night operations.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke={gold} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="9" />
        <circle cx="12" cy="12" r="3.5" />
        <path d="M12 3v5.5M12 15.5V21M3 12h5.5M15.5 12H21" />
      </svg>
    ),
    title: 'Wheels & Tyres',
    text: 'All-terrain, mud, and sand tyre options with reinforced rims sized for every Acriolis model.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke={gold} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 14a4 4 0 0 1 4-4h12v4a4 4 0 0 1-4 4H4v-4Z" />
        <path d="M8 10V7.5A2.5 2.5 0 0 1 10.5 5H14M4 18v-4" />
      </svg>
    ),
    title: 'Winches & Recovery',
    text: 'Factory-grade winches with synthetic rope, tow hooks, and recovery boards for self-reliance anywhere.',
  },
];

function Accessories() {
  return (
    <div>
      <Header />

      {/* ── Page header ── */}
      <section className="acc-hero">
        <h1 className="acc-hero__heading">Parts, Gear &amp; Accessories</h1>
        <p className="acc-hero__sub">
          Everything you need to ride harder, haul more, and stay protected — built and
          tested for Acriolis ATVs.
        </p>
      </section>

      {/* ── Categories ── */}
      <section className="acc-grid-wrap">
        <div className="acc-grid">
          {categories.map((c) => (
            <div className="acc-card" key={c.title}>
              <span className="acc-card__icon">{c.icon}</span>
              <h3 className="acc-card__title">{c.title}</h3>
              <p className="acc-card__text">{c.text}</p>
              <Link to="/contact" className="acc-card__link">
                Enquire <span>→</span>
              </Link>
            </div>
          ))}
        </div>
      </section>

      {/* ── Custom fabrication CTA ── */}
      <section className="acc-custom">
        <div className="acc-custom__inner">
          <h2 className="acc-custom__heading">Need something unique?</h2>
          <p className="acc-custom__text">
            If you have a unique requirement, we provide custom fabrication — ensuring your
            vehicle meets your exact performance and utility needs. Tell us what you're
            building, and our engineers will make it real.
          </p>
          <Link to="/contact" className="acc-custom__btn">
            Request Custom Fabrication <span>→</span>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Accessories;
